import React, { useEffect, useState } from "react";
import moment from "moment";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Modal from "@material-ui/core/Modal";
import axios from "axios";
import IconBack from '@material-ui/icons/ArrowLeft'
import IconRight from '@material-ui/icons/ArrowRight'
import {priceFormatter,CURRENCY_SYMBOLS} from '../../../helpers/general.helper'

import CircularProgress from '@material-ui/core/CircularProgress';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import IconBarChart from "@material-ui/icons/BarChart";


const style = {
  color: "#fff",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  minHeight: 500,
  bgcolor: "var(--dark)",
  border: "2px solid var(--backgroundcolor)",
  boxShadow: 24,
  p: 1,
  padding: '8px 25px 2px 7px'
};


function PriceGraph(props) {
  const [data, setData] = useState([]);
  const [loading,setLoading]=useState(false)
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [startDate,setStartDate]=useState(null)
  const [endDate,setEndDate]=useState(null)
 
  useEffect(()=>{
    if (props.query && props.query != "") 
    if(props.selectedDate)
   {
    let _startDate=moment(props.selectedDate).subtract(15,'days');
    let _endDate=moment(props.selectedDate).endOf('month')

    setStartDate(_startDate);
    setEndDate(_endDate)
     }
  },[props.query,props.selectedDate])

  const getPrice=async ()=>
  {
    if(!startDate&&!endDate)
    return;
    
    setLoading(true)
 
        let newQuery = `${props.query}&date_from=${startDate.format(
          "DD/MM/yyyy"
        )}&&date_to=${endDate.format(
          "DD/MM/yyyy"
        )}&one_per_date=1&sort=price`;
    let response2 = await axios.get(newQuery);
    if (response2 && response2.data && response2.data.data) {
      let result=[];
      let data = response2.data.data.data;
      if(data){
      let sortedArr=data.sort((a,b)=>new Date(a.local_departure)-new Date(b.local_departure));
    
      for(let i=0;i<sortedArr.length;i++)
        {
         let sorted=sortedArr[i]
         let dt=new Date(sorted.local_departure)
          result.push({    
            name: `${dt.getUTCDate()}/${dt.getUTCMonth()+1}`,
            amt: sorted.price,
            Price:  sorted.price
          })            
        }
      }
    setLoading(false)
    setData(result);
      
    }
  }

  useEffect(()=>{
getPrice();
  },[startDate,endDate])

  const handleNext=()=>{
    let _startDate;
    
     _startDate=startDate.add(1,'month').startOf('month');
  
    //  if(_startDate.get('month')==moment().get('month'))
    //  {
    //   _startDate=_startDate.subtract(15,'days');
    //  }
    let _endDate=endDate.add(1,'month').endOf('month')
    // console.log('Next Move--->>',moment(_startDate).format('DD/MM/YYYY'),moment(_endDate).format('DD/MM/YYYY'))
   
    setStartDate(moment(_startDate))
    setEndDate(moment(_endDate))
  }
  const handlePrev=()=>{
    if(moment(startDate).isAfter(moment()))
 {
   let _startDate=startDate.subtract(1,'month').startOf('month');
  //  if(_startDate.get('month')==moment().get('month'))
  //  {
  //   _startDate=_startDate.subtract(15,'days');
  //  }
   let _endDate=endDate.subtract(1,'month')
   setStartDate(moment(_startDate))
    setEndDate(moment(_endDate))
  }
  }

  let today=new Date()
  if(props.selectedDate)
   {today=new Date(props.selectedDate)}
let todayDate=`${today.getUTCDate()+1}/${today.getUTCMonth()+1}`
  return (
    <>
      <div
        className="action-button"
        onClick={handleOpen}
        style={{ paddingLeft: 10 }}
      >
        <Typography
          component="span"
          style={{ color: "var(--darker)", textTransform: "capitalize" }}
        >
          {" "}
        Price Graph &nbsp; <IconBarChart color={"var(--darker)"} />
        </Typography>
      </div>
      {open&&
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="widget-chart-wrapper widget-chart-wrapper-lg he-auto opacity-10 m-0">
          <Box sx={style}>
            <Typography component="p" style={{ color: "var(--darker)" }}>
              Price Graph {startDate&&(moment(startDate).format("DD-MMM-YYYY"))} -{endDate&&(moment(endDate).format("DD-MMM-YYYY"))} 
            </Typography>
            <br />
            {data&&data.length>0?
            <div style={{display:'flex',flex:1,flexDirection:'row',alignItems:'center'}}>
<div style={{width:'5%'}}>
 {startDate&&moment(startDate).isAfter(moment())&& <a className="prev-next-button" onClick={handlePrev}><IconBack style={{fontSize:'40px'}}/></a>}
</div>
<div style={{width:'90%',minHeight:'500px'}}>
          { loading?<div style={{textAlign:'center'}}><CircularProgress color="var(--backgroundcolor)" size={40} /></div> :
  <ResponsiveContainer height={500} width={"99%"}>
              <BarChart
                width={500}
                height={300}
                data={data}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" stroke="#ffffff" />
                <XAxis dataKey="name" style={{color:'#fff'}}/>
                <YAxis  style={{color:'#fff'}}/>
                <Tooltip  wrapperStyle={{ minWidth: 100, backgroundColor: '#54616A',color:'#fff' }}/>
                {/* <Legend /> */}
                {/* <Bar dataKey="pv" fill="#8884d8" /> */}
                <Bar dataKey="Price" label="Price" fill="#01A05A" >
                {
                        data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={todayDate==entry.name?"#01A05A":"#889197"} />
                        ))
                    }
                </Bar>
              </BarChart>
            </ResponsiveContainer>
}
</div>
            <div style={{width:'5%',textAlign:'left'}}>
  <a className="prev-next-button" onClick={handleNext}><IconRight  style={{fontSize:'40px'}}/></a>
</div>
            </div>:<>
          
            </>}
          </Box>
        </div>
      </Modal>}
    </>
  );
}
export default PriceGraph;

PriceGraph.defaultProps = {
  query: "",
  selectedDate: new Date(),
};
